import React, { useCallback } from "react";
import { GoodsamInsuranceDesktopTableTd, GoodsamInsuranceDesktopTableTh, GoodsamInsuranceDesktopTableDeductibleTd } from "../index";
import { PLAN_NAMES, SPEC_RENDER_IDS } from "../../constants";
import classes from "./GoodsamInsuranceDesktopTable.module.css";
import cn from 'classnames';

const getColumnClasses = (item, index, selectedPlanIndex) => cn(
  classes.column,
  index > 0 && selectedPlanIndex === index - 1 && classes.columnSelected,
  item?.planName === PLAN_NAMES.BETTER && classes.boxBorder,
);

const getColumnContainerClasses = (index, itemsLength) => cn(
  classes.columnContainer,
  index === 0 && classes.firstColumnContainer,
  index !== 0 && classes.planColumnContainer,
  index === 1 && classes.firstPlanColumnContainer,
  index === itemsLength - 1 && classes.lastColumn
);

const getSelectedPlanIndex = (selectedPlan, tableThs) => selectedPlan
  ? tableThs.findIndex((item) => item.id === selectedPlan.id) - 1
  : tableThs.findIndex((item) => item.isDefault) - 1;

export const GoodsamInsuranceDesktopTable = (props) => {
  const { tableTds = [], tableThs = [], plans = [], selectedPlan, onSelectInsurance, specRenderFromProps } = props;
  const selectedPlanIndex = getSelectedPlanIndex(selectedPlan, tableThs);

  const handleColumnClick = useCallback((item) => {
    const planId = item.planId || item.id;
    const originalPlan = plans.find(plan => plan.id === planId);
    onSelectInsurance(originalPlan || item);
  }, [onSelectInsurance, plans]);

  const handleSpecRender = useCallback((item, index) => {
    if (item.id === SPEC_RENDER_IDS.DEDUCTIBLE) {
      return (
        <GoodsamInsuranceDesktopTableDeductibleTd
          {...item}
          isSelectedPlan={index > 0 && selectedPlanIndex === index - 1}
        />
      );
    }
  }, [selectedPlanIndex]);

  return (
    <div className={classes.container}>
      <table className={classes.table}>
        <thead>
          <tr className={classes.tr}>
            {tableThs.map((item, index) => (
              <th key={item.id} className={cn(classes.th, index === 0 && classes.firstColumn)}>
                <div className={getColumnContainerClasses(index, tableThs.length)}>
                  <div
                    className={getColumnClasses(item, index, selectedPlanIndex)}
                    onClick={() => {
                      if (index > 0) {
                        handleColumnClick(item);
                      }
                    }}
                  >
                    <GoodsamInsuranceDesktopTableTh
                      {...item}
                      isSelectedPlan={
                        index > 0 && selectedPlanIndex === index - 1
                      }
                    />
                  </div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableTds.map(({ items }, rowIndex) => (
            <tr key={rowIndex} className={cn(classes.tr, classes.trLast)}>
              {items.map((item, index) => {
                const specRender = specRenderFromProps
                  ? specRenderFromProps(item, index)
                  : handleSpecRender(item, index);

                return (
                  <td
                    key={index}
                    className={cn(
                      classes.td,
                      index === 0 && classes.firstColumn,
                    )}
                  >
                    <div
                      className={getColumnContainerClasses(index, items.length)}
                    >
                      <div
                        className={getColumnClasses(
                          item,
                          index,
                          selectedPlanIndex,
                        )}
                        onClick={() => {
                          if (index > 0) {
                            handleColumnClick(item);
                          }
                        }}
                      >
                        {specRender ? (
                          specRender
                        ) : (
                          <GoodsamInsuranceDesktopTableTd {...item} />
                        )}
                      </div>
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
